import { useQueryClient, useMutation } from "@tanstack/react-query";

import { QUERY_KEYS } from "../constants";
import api from "../api";

const client = api();

export default function useSurveyMutation({ id, survey }, options = {}) {
  const queryClient = useQueryClient();

  const {
    mutate: completeSurvey,
    isLoading: isSurveyLoading,
    isError: surveyError,
  } = useMutation(() => client.completeSurvey(survey), {
    ...options,
    onSuccess: async () => {
      await queryClient.invalidateQueries([QUERY_KEYS.ELEMENT, id]);
      options.onSuccess?.();
    },
  });

  return {
    completeSurvey,
    isSurveyLoading,
    surveyError,
  };
}
